var map = {
	"./119131392_1777126519091866_1411076534981267829_n": 25,
	"./119131392_1777126519091866_1411076534981267829_n.jpg": 25,
	"./3Logo": 26,
	"./3Logo.png": 26,
	"./4 year": 27,
	"./4 year.png": 27,
	"./4_year": 28,
	"./4_year-2": 29,
	"./4_year-2.png": 29,
	"./4_year.png": 28,
	"./Group 5810": 30,
	"./Group 5810.svg": 30,
	"./IMG_0207": 31,
	"./IMG_0207.jpg": 31,
	"./Rectangle 1685": 32,
	"./Rectangle 1685.png": 32,
	"./archi-1": 33,
	"./archi-1.png": 33,
	"./archi-10": 34,
	"./archi-10.png": 34,
	"./archi-11": 35,
	"./archi-11.png": 35,
	"./archi-12": 36,
	"./archi-12.png": 36,
	"./archi-13": 37,
	"./archi-13.png": 37,
	"./archi-2": 38,
	"./archi-2-ver-2": 39,
	"./archi-2-ver-2.png": 39,
	"./archi-2.png": 38,
	"./archi-3": 40,
	"./archi-3.png": 40,
	"./archi-4": 41,
	"./archi-4.png": 41,
	"./archi-5": 42,
	"./archi-5.png": 42,
	"./archi-6": 43,
	"./archi-6.png": 43,
	"./archi-7": 44,
	"./archi-7.png": 44,
	"./archi-8": 45,
	"./archi-8.png": 45,
	"./archi-9": 46,
	"./archi-9.png": 46,
	"./ashida-mov": 47,
	"./ashida-mov.jpg": 47,
	"./avata-duck": 48,
	"./avata-duck.png": 48,
	"./avatar-chat": 49,
	"./avatar-chat.png": 49,
	"./avt-mr-nhat": 50,
	"./avt-mr-nhat.png": 50,
	"./avt-nhat": 51,
	"./avt-nhat.png": 51,
	"./benefit": 52,
	"./benefit.png": 52,
	"./bg-map": 53,
	"./bg-map.png": 53,
	"./bg-slide": 54,
	"./bg-slide.png": 54,
	"./bg_slide": 55,
	"./bg_slide.png": 55,
	"./ceo-ashida": 56,
	"./ceo-ashida-2": 57,
	"./ceo-ashida-2.png": 57,
	"./ceo-ashida.jpg": 56,
	"./ceo-phuc": 58,
	"./ceo-phuc-2": 59,
	"./ceo-phuc-2.jpg": 59,
	"./ceo-phuc-2_tmp10016": 158,
	"./ceo-phuc.jpg": 58,
	"./cer-icon": 60,
	"./cer-icon.png": 60,
	"./certificate-img": 19,
	"./certificate-img.jpg": 159,
	"./certificate-img.png": 19,
	"./customer": 61,
	"./customer.jpg": 61,
	"./health": 20,
	"./health.png": 20,
	"./health.svg": 160,
	"./icon-mobile": 62,
	"./icon-mobile.png": 62,
	"./icon-orther": 63,
	"./icon-orther.png": 63,
	"./icon-webapp": 64,
	"./icon-webapp.png": 64,
	"./img-about-1": 65,
	"./img-about-1.JPG": 161,
	"./img-about-1.png": 65,
	"./img-about-2": 66,
	"./img-about-2.JPG": 162,
	"./img-about-2.png": 66,
	"./img-about-3": 67,
	"./img-about-3.JPG": 163,
	"./img-about-3.png": 67,
	"./img-about-4": 21,
	"./img-about-4.jpg": 164,
	"./img-about-4.png": 21,
	"./img-about-5": 68,
	"./img-about-5.jpg": 68,
	"./img-avatar": 69,
	"./img-avatar.png": 69,
	"./img-bg-mision": 70,
	"./img-bg-mision.png": 70,
	"./img-big-thumb": 71,
	"./img-big-thumb.png": 71,
	"./img-mission": 72,
	"./img-mission-ashida": 73,
	"./img-mission-ashida.png": 73,
	"./img-mission.png": 72,
	"./img-misson-dev": 74,
	"./img-misson-dev.png": 74,
	"./img-mov-ashida": 75,
	"./img-mov-ashida.png": 75,
	"./img-new-1": 76,
	"./img-new-1.png": 76,
	"./img-new-2": 77,
	"./img-new-2.png": 77,
	"./img-new-3": 78,
	"./img-new-3.png": 78,
	"./img-suggest-ruby": 79,
	"./img-suggest-ruby.png": 79,
	"./img-video": 80,
	"./img-video.png": 80,
	"./increase": 81,
	"./increase.png": 81,
	"./iwanaga": 82,
	"./iwanaga.jpeg": 82,
	"./label-ico-ruby": 83,
	"./label-ico-ruby.png": 83,
	"./logo": 84,
	"./logo-solution": 85,
	"./logo-solution.png": 85,
	"./logo.png": 84,
	"./mission-bg": 86,
	"./mission-bg.png": 86,
	"./mr-luc": 87,
	"./mr-luc.png": 87,
	"./mr-nhat": 88,
	"./mr-nhat.png": 88,
	"./mr-ui": 89,
	"./mr-ui.jpg": 89,
	"./ms-linh": 90,
	"./ms-linh.png": 90,
	"./new-8": 91,
	"./new-8.png": 91,
	"./new-detail-1": 92,
	"./new-detail-1.png": 92,
	"./news-1": 93,
	"./news-1.png": 93,
	"./news-10": 94,
	"./news-10.png": 94,
	"./news-11": 95,
	"./news-11.png": 95,
	"./news-2": 96,
	"./news-2.png": 96,
	"./news-3": 97,
	"./news-3.png": 97,
	"./news-4": 98,
	"./news-4.png": 98,
	"./news-5": 99,
	"./news-5.png": 99,
	"./news-6": 100,
	"./news-6.png": 100,
	"./news-7": 101,
	"./news-7.png": 101,
	"./news-9": 102,
	"./news-9.png": 102,
	"./partner-1": 103,
	"./partner-1.png": 103,
	"./partner-2": 104,
	"./partner-2.png": 104,
	"./partner-3": 105,
	"./partner-3.png": 105,
	"./partner-4": 106,
	"./partner-4.png": 106,
	"./partner-5": 107,
	"./partner-5.png": 107,
	"./partner-6": 108,
	"./partner-6.png": 108,
	"./partner-7": 109,
	"./partner-7.png": 109,
	"./partner-8": 110,
	"./partner-8.png": 110,
	"./plane": 22,
	"./plane.png": 22,
	"./plane.svg": 165,
	"./quote-1": 111,
	"./quote-1.png": 111,
	"./quote-2": 112,
	"./quote-2.png": 112,
	"./ruby-ico": 113,
	"./ruby-ico-large": 114,
	"./ruby-ico-large.png": 114,
	"./ruby-ico-no-shadow": 115,
	"./ruby-ico-no-shadow.png": 115,
	"./ruby-ico.png": 113,
	"./service-img": 116,
	"./service-img-2": 117,
	"./service-img-2.png": 117,
	"./service-img-orther": 118,
	"./service-img-orther.png": 118,
	"./service-img.png": 116,
	"./time": 119,
	"./time.png": 119,
	"./x-icon-ruby": 120,
	"./x-icon-ruby.png": 120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;